'use client'

import { InviteFriendsButton } from '@/components/common/InviteFriendsButton'
import { HeaderUserDropdown } from '@/components/header/HeaderUserDropdown'
import { MessagesHeaderButton } from '@/components/inbox/MessagesHeaderButton'
import { NotificationBell } from '@/components/notifications/NotificationBell'
import { cn } from '@/lib/utils'

type AppHeaderActionsProps = {
  loggedIn: boolean
  userId: any
  features: any
  isAffiliateActive: boolean
  inviteUrl: string | null
  className?: string
}

export default function AppHeaderActions({
  loggedIn,
  userId,
  features,
  isAffiliateActive,
  inviteUrl,
  className,
}: AppHeaderActionsProps) {
  if (!loggedIn) {
    return null
  }

  return (
    <div
      className={cn(
        'flex items-center gap-2 ml-auto',
        className
      )}
    >
      <NotificationBell />

      <MessagesHeaderButton userId={userId} />

      {features?.affiliate_invites &&
      isAffiliateActive &&
      inviteUrl ? (
        <InviteFriendsButton url={inviteUrl} />
      ) : null}

      <HeaderUserDropdown />
    </div>
  )
}